<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <a href="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                            {{ $t('Главная') }}
                        </v-breadcrumbs-item>
                    </a>
                </v-breadcrumbs>
                <div>
                    <h1 class="section-title-main my-3 font-weight-regular">{{ $t('Обучение') }}</h1>

                    <StudyCards />
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import StudyCards from '@/components/view_blocks/Study/Study_cards.vue';

export default {
  name      : 'Study',
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    StudyCards,
  },
};
</script>
